import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FacetList from './FacetList';
import styles from './styles.module.scss';
import usePagination from '@app/components/pages/plp/usePagination';
import { isEmpty } from '@app/utils';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { getActiveFacets } from '@app/components/pages/marketing/components/ProductCardGrid/utils';
import { activeFacetsPropTypes } from '../../SpecificationFacets/declarations.propTypes';
import { getFacetsWithSubValues } from '@app/store/plp/utils';
import { Fragment } from 'react';
import { filterSpecialFacets } from '../../SpecificationFacets/utils';

const SpecificationFacets = ({
  facets,
  isModal,
  activeFacets,
  queryActionParam,
  widgetId,
  fbeEnabled
}) => {
  const { setUrlToPageOneWithFilter } = usePagination();
  const dispatch = useDispatch();
  const { hash } = useLocation();
  const pccSpecialsOnSearchAndCategoryPages = useSelector(
    s => s.featureFlag.PCC_SpecialsOnSearchAndCategoryPages
  );
  const { facets: facetsFromHash } = queryString.parse(hash);
  const facetsArray = !Array.isArray(facetsFromHash)
    ? [facetsFromHash]
    : facetsFromHash;

  const updatedFacets = filterSpecialFacets(
    pccSpecialsOnSearchAndCategoryPages,
    facets
  );

  const handleChange = ({ target: { value, checked } }) => {
    const {
      orderBy: orderByFromUrl,
      filterByEquipment: filterByEquipmentFromUrl
    } = queryString.parse(hash);
    const { facet, label, uom, groupLabel } = JSON.parse(value);
    const newActiveFacets = checked
      ? activeFacets?.concat({
          facet,
          label,
          uom,
          ...(groupLabel && { groupLabel })
        })
      : activeFacets.filter(({ facet: activeFacet }) => activeFacet !== facet);
    const orderByUrl = orderByFromUrl ? 'orderBy' : 'sortBy';
    dispatch(
      queryActionParam(
        widgetId
          ? {
              widgetId: widgetId,
              data: {
                activeFacets: newActiveFacets,
                pageNumber: 1,
                batchPartNumbers: []
              }
            }
          : { activeFacets: newActiveFacets },
        true
      )
    );
    if (!checked) {
      activeFacets.forEach(item => {
        const facetWithWidgetId = `${item.facet}|${widgetId}`;
        facetsArray.splice(facetsArray.indexOf(facetWithWidgetId), 1);
      });
    }
    setUrlToPageOneWithFilter(
      widgetId
        ? {
            filterByEquipment: filterByEquipmentFromUrl,
            facets: getActiveFacets(facetsArray, newActiveFacets, widgetId),
            [orderByUrl]: orderByFromUrl,
            isMarketingPage: true,
            fbeEnabledValue: fbeEnabled
          }
        : { facets: newActiveFacets }
    );
  };

  if (isEmpty(updatedFacets)) {
    return null;
  }
  return updatedFacets?.map(
    ({ label, facetId, facetGroupShouldBeDisabled, value: facetValues }) => {
      const facetsWithSubValues = getFacetsWithSubValues(facetValues);

      return (
        <Fragment key={`${label}-${facetId}`}>
          <h6
            className={cx(
              'fw-normal ps-2 text-sm text-uppercase u-color--ExtraDarkGray text-univers--bold',
              {
                [styles['facet-group-title']]: facetGroupShouldBeDisabled
              }
            )}
          >
            {label}
          </h6>
          {!facetGroupShouldBeDisabled && (
            <FacetList
              facetValues={facetsWithSubValues}
              handleChange={handleChange}
              isModal={isModal}
              activeFacets={activeFacets}
              widgetId={widgetId}
            />
          )}
          <hr />
        </Fragment>
      );
    }
  );
};

SpecificationFacets.propTypes = {
  facets: PropTypes.arrayOf(
    PropTypes.shape({
      allValuesReturned: PropTypes.bool,
      allowMultipleValueSelection: PropTypes.bool,
      facetId: PropTypes.string,
      label: PropTypes.string,
      uom: PropTypes.string,
      value: PropTypes.arrayOf(
        PropTypes.shape({
          count: PropTypes.number,
          facet: PropTypes.string,
          label: PropTypes.string
        })
      )
    })
  ).isRequired,
  activeFacets: activeFacetsPropTypes,
  isModal: PropTypes.bool,
  queryActionParam: PropTypes.func,
  fbeEnabled: PropTypes.bool,
  widgetId: PropTypes.string
};

export default SpecificationFacets;
